var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "back-my"
  }, [_c('img', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/icon_back.png",
      "alt": ""
    },
    on: {
      "click": _vm.goBack
    }
  })]), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333268'
  })))]), _c('h2', [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333259'
  })) + " ")]), _vm.store.isInApp ? _c('div', {
    staticClass: "icons"
  }, [_c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/icon_share.png",
      "alt": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.goShare.apply(null, arguments);
      }
    }
  })], 1) : _vm._e()]), !_vm.store.loading ? _c('div', {
    staticClass: "cont"
  }, [_vm.store.isInApp ? _c('box', {
    attrs: {
      "title": _vm.$k18n({
        id: 'k_333269'
      })
    }
  }, [_c('my-info'), _c('mission')], 1) : _c('out-mission'), _c('div', {
    class: {
      copyright: true,
      mt: !_vm.store.isInApp
    }
  }, [_vm._v(" " + _vm._s(_vm.$k18n({
    id: 'k_333265'
  })) + " ")])], 1) : _c('loading', {
    attrs: {
      "show": true,
      "color": "#FFDBA8"
    }
  }), _vm.store.toastFlag ? _c('div', {
    staticClass: "share-toast"
  }, [_c('div', {
    staticClass: "cb"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('span', [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333295',
    params: {
      '0': _vm.$k18n({
        id: _vm.store.toastData.text
      }),
      '1': _vm.store.toastData.val
    }
  })))]), _c('k-image', {
    attrs: {
      "src": "//cdn-static.kwai.net/kos/s101/nlav11312/live/events/global/tick.png",
      "alt": ""
    }
  })], 1)])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }